import React from 'react'

import { NavLink } from 'react-router-dom'

import { reverse } from 'routes'

import './index.scss'

export default function (props) {
  return (
    <aside className="Dashboard__container__sidebar">
      <ul>
        <li>
          <NavLink to={reverse('claims')} className="d-inline-flex align-items-centes" activeClassName="active" exact>
            <span className="material-icons cl-achromatic-b-color">directions_car</span>
            <p className="cl-achromatic-b-color bold-text">Siniestros</p>
          </NavLink>
        </li>
        <li>
          <NavLink to={reverse('clients')} className="d-inline-flex align-items-center" activeClassName="active" exact>
            <span className="material-icons cl-achromatic-b-color">people</span>
            <p className="cl-achromatic-b-color bold-text">Clientes</p>
          </NavLink>
        </li>
      </ul>
    </aside>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/SideBar/index.js